var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import React, { useState } from "react";
import { observer } from "mobx-react";
import { Trans } from "react-i18next";
import { message } from "antd";
import { pick } from "lodash";
import { Permissions } from "@whatsper/texterchat-common";
import { useStore } from "../../../../store/rootStore";
import { Operation } from "../../../EntityManager";
import { ManagerDetailsView } from "../core";
import DepartmentForm from "./components/DepartmentForm";
import { agentPropertiesEditable } from "../agents/components/helpers";
const DepartmentsDetailsView = observer(({ entityId, operation, onCancel, onCompleted, }) => {
    const { departmentsStore, agentsStore, dashboard } = useStore();
    const [loading, setLoading] = useState(false);
    const entity = (() => {
        if (!entityId || operation === Operation.CREATE)
            return null;
        return departmentsStore.departments.find((d) => d._id === entityId) || null;
    })();
    const renderDeleteQuestion = (department) => {
        return React.createElement(Trans, { i18nKey: "sureDeleteName", values: department });
    };
    const updateDepartmentAgents = (departmentId, agentId, op) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const agent = agentsStore.users.find((agent) => agent._id === agentId);
            const departments = departmentsStore.departments
                .filter(({ agents }) => agents === null || agents === void 0 ? void 0 : agents.includes(agentId))
                .map(({ _id }) => _id);
            const departmentsUpdated = op === "add"
                ? [...departments, departmentId]
                : departments.filter((_id) => _id !== departmentId);
            if (agent) {
                const agentEditable = pick(agent, [...agentPropertiesEditable]);
                yield agentsStore.editUser(agent._id, agentEditable, departmentsUpdated);
            }
        }
        finally {
            setLoading(false);
        }
    });
    const handleSave = (formData, existingDepartment) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            const sla = {
                time: formData.isSlaEnabled && formData.slaTime
                    ? dashboard.parseSlaTimeFromMomentToMilliseconds(formData.slaTime)
                    : 0,
            };
            if (existingDepartment) {
                yield departmentsStore.editDepartment(Object.assign(Object.assign(Object.assign({}, existingDepartment), pick(formData, ["name", "color", "_id", "workingHours"])), { sla }));
                message.success(React.createElement(Trans, { i18nKey: "departmentEditSuccess", values: { name: formData.name } }));
            }
            else {
                yield departmentsStore.createDepartment(Object.assign(Object.assign({}, pick(formData, ["name", "color", "_id", "workingHours"])), { sla }));
                message.success(React.createElement(Trans, { i18nKey: "departmentCreateSuccess", values: { name: formData.name } }));
            }
            yield departmentsStore.fetchDepartments();
        }
        catch (error) {
            console.error("Failed to save department:", error);
            message.error(React.createElement(Trans, { i18nKey: "departmentSaveError" }));
            throw error;
        }
        finally {
            setLoading(false);
        }
    });
    const handleDelete = (department) => __awaiter(void 0, void 0, void 0, function* () {
        setLoading(true);
        try {
            yield departmentsStore.deleteDepartment(department._id);
            message.success(React.createElement(Trans, { i18nKey: "departmentDeleteSuccess", values: { name: department.name } }));
            yield departmentsStore.fetchDepartments();
        }
        catch (error) {
            console.error("Failed to delete department:", error);
            message.error(React.createElement(Trans, { i18nKey: "departmentDeleteError" }));
            throw error;
        }
        finally {
            setLoading(false);
        }
    });
    const canDelete = agentsStore.hasPermissions([Permissions.Permission.departments_manage]);
    return (React.createElement(ManagerDetailsView, { entity: entity, entityId: entityId, operation: operation, form: DepartmentForm, formProps: {
            updateDepartmentAgents,
        }, loading: loading, initialLoading: !departmentsStore.departments.length, renderDeleteQuestion: renderDeleteQuestion, onEntitySave: handleSave, onEntityDelete: canDelete ? handleDelete : undefined, onCancel: onCancel, onSaveCompleted: onCompleted, onDeleteCompleted: onCompleted }));
});
export default DepartmentsDetailsView;
